import { cn } from "@design-system/utils";
import React, { type ComponentProps, type ReactNode } from "react";

import { FilterBarClear } from "./filter-bar-clear";
import { FilterBarMenu } from "./filter-bar-menu";
import { FilterBarMultiSelect } from "./filter-bar-multi-select";
import { FilterBarSearch } from "./filter-bar-search";

interface FilterBarProps extends ComponentProps<"div"> {
  controls?: ReactNode;
}

function FilterBar({
  children,
  controls,
  className,
  ...props
}: FilterBarProps) {
  return (
    <div
      data-slot="filter-bar"
      className={cn("flex items-start gap-2", className)}
      {...props}
    >
      <div
        data-slot="filter-bar-filters"
        className="flex min-w-0 flex-1 flex-wrap items-start gap-2"
      >
        {children}
      </div>
      {controls ? (
        <div
          data-slot="filter-bar-controls"
          className="flex shrink-0 items-center gap-2"
        >
          {controls}
        </div>
      ) : null}
    </div>
  );
}

FilterBar.Search = FilterBarSearch;
FilterBar.MultiSelect = FilterBarMultiSelect;
FilterBar.Clear = FilterBarClear;
FilterBar.Menu = FilterBarMenu;

export { FilterBar };
export type { FilterBarProps };
